"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Embedding", {
  enumerable: true,
  get: function () {
    return _Embedding.default;
  }
});

var _Embedding = _interopRequireDefault(require("./Embedding"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }